import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="pt-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route
              path="/services/residential-conveyancing"
              element={<ServiceDetail slug="residential-conveyancing" />}
            />
            <Route
              path="/services/commercial-property"
              element={<ServiceDetail slug="commercial-property" />}
            />
            <Route
              path="/services/business"
              element={<ServiceDetail slug="business" />}
            />
            {/* Legacy redirects */}
            <Route
              path="/services/conveyancing"
              element={<Navigate to="/services/residential-conveyancing" replace />}
            />
            <Route
              path="/services/commercial-business-law"
              element={<Navigate to="/services/commercial-property" replace />}
            />
            <Route
              path="/services/property-law"
              element={<Navigate to="/services/commercial-property" replace />}
            />
            <Route
              path="/request-quote"
              element={<Navigate to="/contact" replace />}
            />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "#FFFFFF",
              color: "#1A1E19",
              border: "1px solid #D7E0D5",
              borderRadius: "2px",
              fontFamily: "Aptos, Inter, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
